import { TierartEnum } from '@ps20-frontend/frontend-models';
import { ProdukttabelleEnum } from '@ps20-frontend/shop-integration-redux';

export const tkvProdukttabelle = (tierart: TierartEnum): ProdukttabelleEnum =>
  ({
    [TierartEnum.HUND]: ProdukttabelleEnum.TKV_V2_HUND_OPSCHUTZ,
    [TierartEnum.PFERD]: ProdukttabelleEnum.TKV_V2_PFERD_OPSCHUTZ,
    [TierartEnum.KATZE]: ProdukttabelleEnum.TKV_V2_KATZE_OPSCHUTZ,
  })[tierart];
